import { useMemo } from 'react';

import {
	ComposableTypography,
	ComposableTypographyProps,
	ComposableTypographyTags,
	ResponsiveTypographySxProp,
	TypographyAppearance,
	TypographyColorToken,
	useTheme,
} from '@bcp-nextgen-dx-component-factory/design-system';

type TUseTypographyTags = {
	colorToken?: TypographyColorToken;
};

export const useTypographyTags = ({ colorToken }: TUseTypographyTags) => {
	const { typography } = useTheme();

	return useMemo(() => {
		const tags: ComposableTypographyTags = {};

		Object.keys(typography.appearances).forEach((x) => {
			tags[x] = { appearance: x as TypographyAppearance, colorToken };
		});

		return tags;
	}, [colorToken, typography.appearances]);
};

export interface AppComposableTypographyProps extends Pick<ComposableTypographyProps, 'textAlign'> {
	appearance?: TypographyAppearance;
	text?: string;
	colorToken?: TypographyColorToken;
	sx?: ResponsiveTypographySxProp;
}

export const AppComposableTypography = ({
	appearance,
	text,
	colorToken,
	textAlign,
	sx,
}: AppComposableTypographyProps) => {
	const tags = useTypographyTags({ colorToken });

	if (!text) {
		return null;
	}

	return (
		<ComposableTypography
			baseProps={{ appearance: appearance, colorToken, sx }}
			tags={tags}
			text={text}
			textAlign={textAlign}
		/>
	);
};
